import React from "react";
import { useTranslation } from "react-i18next";
import { FmBasicModal, FmButton, FmUnderlineNav } from "../..";
import { useIsMobile } from "../../../Hooks";

import useStyles from "./FmDeleteItemModal.style";

interface FmDeleteItemModalProps {
  img: any;
  isOpen: any;
  onClose: any;
  onAction: any;
}

const FmDeleteItemModal = ({ img, isOpen, onClose, onAction }: FmDeleteItemModalProps) => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  const handleClearMyData = () => {
    onClose();
  };

  return (
    <FmBasicModal img={img} onClose={onClose} isOpen={isOpen}>
      <div className={isMobile ? classes.mobile_rightSide : classes.rightSide}>
        <div className={classes.mobile_box}>
          <span className={isMobile ? classes.mobile_title : classes.title}>{t("deleteItemPopup.title")}</span>
          <span className={isMobile ? classes.mobile_subTitle : classes.subTitle}>{t("deleteItemPopup.subTitle")}</span>
        </div>
        {isMobile ? (
          <div className={classes.mobile_buttons_container}>
            <FmButton fullWidth="fullWidth" onClick={onAction}>
              {t("deleteItemPopup.yes")}
            </FmButton>
            <div className={classes.mobile_noThanks}>
              <FmUnderlineNav title={t("deleteItemPopup.no")} onClick={onClose} />
            </div>
          </div>
        ) : (
          <div className={classes.buttons_container}>
            <FmButton fullWidth={"whiteButton"} onClick={onClose}>
              {t("deleteItemPopup.no")}
            </FmButton>

            <FmButton fullWidth="regular" onClick={onAction}>
              {t("deleteItemPopup.yes")}
            </FmButton>
          </div>
        )}
      </div>
    </FmBasicModal>
  );
};

export default FmDeleteItemModal;
